import React from 'react'
import Toppercarousel from './Toppercarousel'

function Topper() {
    return (
        <div>
            <div className='eventinfo'>
                <h3>Topper <span style={{ fontSize: '1rem',   textAlign: "center", }}></span></h3>
                <hr />
                <Toppercarousel />

            </div>
        </div>
    )
}

export default Topper
